module.exports = "/_next/static/images/d5e002e138442f0dd9aaa701a6327373-careers@3x.jpg.webp";